var exports = {
  "container": "x0a7806d5--d23b5f--container",
  "small": "x0a7806d5--d23b5f--small",
  "big": "x0a7806d5--d23b5f--big",
};

module.exports = exports;
